const DEFAULT_PROFILE_IMAGE_VARIANTS = ['square-small2x', 'square-small', 'default'];

const getPublicData = entityOrPublicData => {
  if (!entityOrPublicData) {
    return {};
  }

  if (entityOrPublicData.attributes?.profile?.publicData) {
    return entityOrPublicData.attributes.profile.publicData;
  }

  if (entityOrPublicData.publicData) {
    return entityOrPublicData.publicData;
  }

  return entityOrPublicData;
};

const buildCloudfrontUrl = assetKey => {
  if (!assetKey) {
    return null;
  }

  return `${process.env.REACT_APP_CLOUDFRONT_URL}/${assetKey}`;
};

const getProfileImageEntity = entity => {
  if (!entity) {
    return null;
  }

  return entity.profileImage || entity.attributes?.profile?.profileImage || entity.attributes?.profileImage || null;
};

export const getStoreLogoKey = entityOrPublicData => {
  const publicData = getPublicData(entityOrPublicData);
  return publicData.logoKey || null;
};

export const getStoreLogoUrl = entityOrPublicData => {
  return buildCloudfrontUrl(getStoreLogoKey(entityOrPublicData));
};

export const getUserProfileImageUrl = (
  entity,
  preferredVariants = DEFAULT_PROFILE_IMAGE_VARIANTS
) => {
  const profileImage = getProfileImageEntity(entity);
  if (!profileImage || typeof profileImage === 'string') {
    return null;
  }

  const variants = profileImage.attributes?.variants || {};
  const matchedVariant = preferredVariants.find(variantName => variants[variantName]?.url);

  return matchedVariant ? variants[matchedVariant].url : null;
};

export const getStoreImageUrl = entity => {
  return getStoreLogoUrl(entity) || getUserProfileImageUrl(entity);
};
